"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retryWithDelay = void 0;
const operators_1 = require("rxjs/operators");
const throwIf_1 = require("./throwIf");
// from https://github.com/NiklasPor/rxjs-boost (MIT)
/**
 * Retries an Observable with a [delay].
 * Will retry [count] times. Defaults to `1`.
 *
 * @param delay The delay (milliseconds) the operator will wait before each retry.
 *              This also includes the first try.
 * @param count The number of times the operator will retry the execution.
 *              Defaults to `1`.
 */
function retryWithDelay(delay, count = 1) {
    return input => input.pipe((0, operators_1.retryWhen)(errors => errors.pipe((0, operators_1.scan)((acc, error) => ({ count: acc.count + 1, error }), {
        count: 0,
        error: undefined,
    }), (0, throwIf_1.throwIf)(current => current.count > count, current => current.error), (0, operators_1.delay)(delay))));
}
exports.retryWithDelay = retryWithDelay;
//# sourceMappingURL=retryWithDelay.js.map